import React from 'react';
import { Typography } from '@material-ui/core';
import Skeleton from '../Skeleton';

export default function TextInfo({ label, value, loading }) {
    return (
        <div style={{ display: 'flex' }}>
            <Typography variant="subtitle2">
                <strong style={{ color: 'rgb(0 0 0 / 75%)' }}>
                    {label}
                </strong>
            </Typography>
            <Typography variant="subtitle2" style={{ marginLeft: 4 }}>
                <Skeleton active={loading}>
                    {value}
                </Skeleton>
            </Typography>
        </div>
    )
}